export default [
  {
    path: "/organizations",
    component: () => import("@/views/reports/organizations/ListOrganizations.vue"),
    meta: {
      authorization: { policies: ["verensics-administrator"] },
    },
  },
  {
    path: "/organizations/create",
    component: () => import("@/views/reports/organizations/CreateOrganization.vue"),
    meta: {
      authorization: { policies: ["verensics-administrator"] },
    },
  },
  {
    path: "/organizations/:organizationId",
    props: true,
    component: () => import("@/views/reports/organizations/EditOrganization.vue"),
    redirect: to => to.path + "/profile",
    meta: {
      authorization: { policies: ["verensics-administrator"] },
    },
    children: [
      {
        path: "profile",
        props: true,
        component: () => import("@/views/reports/organizations/EditOrganizationProfile.vue"),
        meta: {
          authorization: { roles: ["organization-administrator"] },
        },
      },
      {
        path: "features",
        props: true,
        component: () => import("@/views/reports/organizations/EditOrganizationFeatures.vue"),
        meta: {
          authorization: { policies: ["verensics-administrator"] },
        },
      },
      {
        path: "tests",
        props: true,
        component: () => import("@/views/reports/organizations/EditOrganizationTests.vue"),
        meta: {
          authorization: { policies: ["verensics-administrator"] },
        },
      },
      {
        path: "regions",
        props: true,
        component: () => import("@/views/reports/organizations/EditOrganizationRegions.vue"),
        meta: {
          authorization: { roles: ["organization-administrator"] },
        },
      },
      {
        path: "facilities",
        props: true,
        component: () => import("@/views/reports/organizations/EditOrganizationFacilities.vue"),
        meta: {
          authorization: { roles: ["organization-administrator"] },
        },
      },
      {
        path: "functions",
        props: true,
        component: () => import("@/views/reports/organizations/EditOrganizationFunctions.vue"),
        meta: {
          authorization: { roles: ["organization-administrator"] },
        },
      },
      {
        path: "companies",
        props: true,
        component: () => import("@/views/reports/organizations/EditOrganizationCompanies.vue"),
        meta: {
          authorization: { roles: ["organization-administrator"] },
        },
      },
      {
        path: "interviews",
        props: true,
        component: () => import("@/views/reports/organizations/EditOrganizationInterviews.vue"),
        meta: {
          authorization: { roles: ["organization-administrator"] },
        },
      },
      {
        path: "questionexclusions",
        props: true,
        component: () => import("@/views/reports/organizations/EditOrganizationQuestionExclusions.vue"),
        meta: {
          authorization: { roles: ["verensics-administrator"] },
        },
      },
      {
        path: "ssoconfig",
        props: true,
        component: () => import("@/views/reports/organizations/EditOrganizationSsoConfig.vue"),
        meta: {
          authorization: { roles: ["verensics-administrator"] },
        },
      },
      {
        path: "internationalization",
        props: true,
        component: () => import("@/views/reports/organizations/EditOrganizationInternationalization.vue"),
        meta: {
          authorization: { roles: ["organization-administrator"] },
        },
      },
    ],
  },
];
